// extracted by mini-css-extract-plugin
export default {"columns2-copy-button":"masterLabel_columns2-copy-button__O5mF-","btn":"masterLabel_btn__ZWb6t"};